import type { DraftLine } from "./useLineDraftState";

const VERSION = 1;

interface StoredDraft {
  version: typeof VERSION;
  draft: DraftLine;
  idempotencyKey: string;
}

function key(userId: string, orgId: string): string {
  return `lineDraft:${userId}:${orgId}`;
}

export function load(userId: string, orgId: string): StoredDraft | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(key(userId, orgId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredDraft;
    if (parsed.version !== VERSION) return null;
    if (!parsed.draft || typeof parsed.idempotencyKey !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function save(
  userId: string,
  orgId: string,
  draft: DraftLine,
  idempotencyKey: string
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    const payload: StoredDraft = { version: VERSION, draft, idempotencyKey };
    sessionStorage.setItem(key(userId, orgId), JSON.stringify(payload));
  } catch {}
}

export function clear(userId: string, orgId: string): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(key(userId, orgId));
}

export const STORAGE_VERSION = VERSION;
